import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Error404 from "../views/Error/404.vue";
import AuthenticationLogin from "../views/Authentication/Login.vue";
import AuthenticationRegister from "../views/Authentication/Register.vue";
import ServerOffline from "../views/Error/ServerOffline";

import DocumentsFrame from "../views/Documents/Frame";
import DocumentsImprint from "../views/Documents/Imprint";
import DocumentsTerms from "../views/Documents/Terms";
import DocumentsPrivacy from "../views/Documents/Privacy";
import DocumentsSystemPolicies from "../views/Documents/SystemPolicies";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/rechtliches",
    component: DocumentsFrame,
    redirect: "/rechtliches/impressum",
    children: [
      {
        path: "impressum",
        component: DocumentsImprint
      },
      {
        path: "agb",
        component: DocumentsTerms
      },
      {
        path: "datenschutz",
        component: DocumentsPrivacy
      },
      {
        path: "system-policies",
        component: DocumentsSystemPolicies
      }
    ]
  },
  // {
  //   path: "/kontakt",
  //   name: "Contact",
  //   component: Home
  // },
  // {
  //   path: "/preise",
  //   name: "Pricing",
  //   component: Home
  // },
  {
    path: "/login",
    component: AuthenticationLogin,
    meta: {
      title: "Anmelden"
    },
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("jwt")) {
        next("/");
      } else {
        next();
      }
    }
  },
  {
    path: "/registrieren",
    component: AuthenticationRegister,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("jwt")) {
        next("/");
      } else {
        next();
      }
    }
  },
  {
    path: "/registrieren/naechste-schritte",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-settings" */ "../views/Authentication/NextSteps.vue"
      )
  },
  // {
  //   path: "/registrieren",
  //   name: "Register",
  //   component: Home
  // },
  // {
  //   path: "/passwort-vergessen",
  //   name: "Recover",
  //   component: Home
  // },
  // {
  //   path: "/neues-passwort",
  //   name: "Reset",
  //   component: Home
  // },
  {
    path: "/konto",
    component: () =>
      import(
        /* webpackChunkName: "dashboard-frame" */ "../views/Dashboard/Frame.vue"
      ),
    redirect: "/konto/server",
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("jwt")) {
        next();
      } else {
        next("/login?next=" + to.path);
      }
    },
    children: [
      {
        path: "server",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-servers" */ "../views/Dashboard/Servers.vue"
          )
      },
      {
        path: "verbrauch",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-settings" */ "../views/Dashboard/Usage.vue"
          )
      },
      {
        path: "einstellungen",
        component: () =>
          import(
            /* webpackChunkName: "dashboard-settings" */ "../views/Dashboard/Settings.vue"
          )
      }
      // {
      //   path: "abrechnung",
      //   name: "Billing",
      //   component: Home
      // },
    ]
  },
  {
    path: "/server-offline/:domain?",
    component: ServerOffline
  },
  {
    path: "**",
    component: Error404
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched
  //  .slice()
  //  .reverse()
  //  .find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle)
    document.title = nearestWithTitle.meta.title + " - ConfCloud";
  else document.title = "ConfCloud";

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;
